import React, { ReactNode } from 'react';
import { IFetchStatus } from '../../../types/rest/IFetchStatus';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Spinner } from '../Spinner';

export interface IFetchStatusFlowProps {
  defaultNode?: ReactNode;
  error?: Error;
  errorCustomNode?: ReactNode;
  errorMessage?: ReactNode;
  fetchingNode?: ReactNode;
  fetchStatus?: IFetchStatus;
  children?: ReactNode;
}

export const FetchStatusFlow: React.FC<IFetchStatusFlowProps> = ({
  children,
  defaultNode,
  error,
  errorCustomNode,
  errorMessage,
  fetchingNode,
  fetchStatus,
}) => {
  const { fetched, fetching, success } = fetchStatus || {};

  return (
    <>
      {!fetched && !fetching && !error && !errorMessage && (defaultNode || <Spinner />)}
      {!fetched && fetching && (fetchingNode || <Spinner />)}
      {fetched && !success && (errorCustomNode || <ErrorMessage error={error} message={errorMessage} />)}
      {fetched && success && children}
    </>
  );
};
